import React from 'react';
import { Fees } from '../../../../api/api-fees';
import * as types from '../constants/action-types';
import { get } from 'lodash';

export function fetchRegionalFeesRequest (isFetching) {
  return {
    type: types.REGIONAL_FEES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchRegionalFeesSuccess (data) {
  return {
    type: types.REGIONAL_FEES_FETCH_SUCCESS,
    data
  };
}

export function fetchRegionalFeesFailure (fetchError) {
  return {
    type: types.REGIONAL_FEES_FETCH_FAILURE,
    fetchError
  };
}

export function fetchRegionalFees (accessToken, payload) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchRegionalFeesRequest(true));

      Fees.fetchRegionalFees(accessToken, payload, response => {
        if (200 === response.statusCode) {
          dispatch(fetchRegionalFeesSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching regional fees';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchRegionalFeesFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}
